import helperFunctions from './functions.js';

const auth = {
    login: (email, password, _callback) => {
        const credentials = {
            email,
            password
        };

        $.post('/api/v2/auth/attempt?lng=' + helperFunctions.getLangInUrl(), credentials).then(function (response) {
            return _callback(response);
        }, "json"), (function () {
            return _callback();
        });
    },

    isAuthenticated: (_callback) => {
        $.get('/api/v2/auth/whoami?lng=' + helperFunctions.getLangInUrl()).then(function (response) {
            return _callback(response);
        }, "json"), (function () {
            return _callback();
        });
    },

    register: (email, password, confirm_password, _callback) => {

        const credentials = {
            email: email,
            password: password,
            passwordc: confirm_password
        };

        $.post('/api/v2/auth/pre-register?lng=' + helperFunctions.getLangInUrl(), credentials).then(function (response) {
            return _callback(response);
        }, function () {
            return _callback();
        });
    }
}

export default auth;